import { Link } from "react-router-dom"
import "./ServicePage.css"

const eligibleGroups = [
  "Adults aged 65 and over",
  "Pregnant women",
  "People with long-term health conditions",
  "Carers and healthcare workers",
  "Children aged 2-3 years (nasal spray)",
  "People living with someone who has a weakened immune system",
]

const benefits = [
  {
    title: "Quick & Convenient",
    description: "No GP appointment needed - just walk in or book online"
  },
  {
    title: "Expert Administration",
    description: "Administered by trained pharmacists in a private consultation room"
  },
  {
    title: "Free for Eligible Groups",
    description: "NHS flu jab is free if you're in an at-risk group"
  },
  {
    title: "Protect Your Loved Ones",
    description: "Reduce the risk of spreading flu to vulnerable family members"
  },
]

const faqs = [
  {
    question: "When should I get the flu vaccine?",
    answer: "The best time to get vaccinated is in the autumn, before flu starts circulating. However, you can still get vaccinated later in the season. The vaccine is typically available from September each year."
  },
  {
    question: "Is the flu vaccine safe?",
    answer: "Yes, the flu vaccine is very safe. It cannot give you the flu as it doesn't contain live viruses. Some people may experience mild side effects like a sore arm or slight temperature, which usually pass within a day or two."
  },
  {
    question: "How much does the flu vaccine cost?",
    answer: "The flu vaccine is free on the NHS if you're in an eligible group. If you're not eligible for a free vaccine, we offer private flu vaccinations for a competitive fee. Please contact us for current pricing."
  },
  {
    question: "Do I need to book an appointment?",
    answer: "While walk-ins are welcome, we recommend booking an appointment to ensure minimal waiting time. You can book online or call us directly."
  },
  {
    question: "Can I have the flu vaccine if I'm unwell?",
    answer: "If you have a fever or feel very unwell, it's best to wait until you've recovered before having the vaccine. Minor illnesses like a cold shouldn't prevent vaccination."
  },
]

function FluVaccinationPage() {
  return (
    <div className="service-page">
      <section className="sp-hero" style={{ background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)" }}>
        <h1>Flu Vaccination</h1>
        <p className="sp-tagline">
          Protect yourself and your loved ones this flu season
        </p>
      </section>

      <section className="sp-intro">
        <p>
          Flu can be a serious illness, especially for vulnerable groups. Getting vaccinated is
          the best way to protect yourself and those around you. Our trained pharmacists can
          administer your flu jab quickly and conveniently, with no need for a GP appointment.
        </p>
        <p>
          The flu vaccine is updated each year to protect against the strains most likely to
          circulate. It takes about two weeks for protection to develop after vaccination.
        </p>
      </section>

      <section className="sp-eligible">
        <h2>Who Can Get a Free NHS Flu Vaccine?</h2>
        <div className="eligible-list">
          {eligibleGroups.map((group, index) => (
            <div key={index} className="eligible-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>{group}</span>
            </div>
          ))}
        </div>
        <p className="eligible-note">
          Even if you're not in an eligible group, we offer private flu vaccinations at a competitive price.
        </p>
      </section>

      <section className="sp-benefits">
        <h2>Why Get Vaccinated at Goosnargh Pharmacy?</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="sp-cta">
        <h2>Book Your Flu Vaccination</h2>
        <p>
          Don't wait until it's too late. Book your flu vaccination today and stay protected
          throughout the season.
        </p>
        <Link to="/services?service=flu-vaccination" className="button primary">
          Book Now
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="sp-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default FluVaccinationPage
